import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Lottie from 'react-lottie';
import DialogContent from '@material-ui/core/DialogContent';
import * as animationDataLoading from '../../assets/animation/loading';
import {useSelector} from 'react-redux';

function LoadingModal() {
  const loading = useSelector((state) => state.misc.isLoading);
  const defaultLoading = {
    loop: true,
    autoplay: true,
    animationData: animationDataLoading.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Dialog
      style={{padding: '0 !important', zIndex: 1500}}
      maxWidth={'xs'}
      open={loading}
    >
      <DialogContent style={{padding: 8}}>
        <Lottie
          options={defaultLoading}
          height={150}
          width={150}
          isClickToPauseDisabled={true}
        />
      </DialogContent>
    </Dialog>
  );
}

export default LoadingModal;
